import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useTranslation } from "react-i18next"; // for localized message

const WhatsappFloat = () => {
  const { t } = useTranslation();

  const phoneNumber = "60105493288"; // <-- your WhatsApp number
  const message = encodeURIComponent(t("whatsappMessage")); // localized message
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <div style={{
      position: "fixed",
      top: "50%",
      right: "20px",
      zIndex: 999,
      transform: "translateY(-50%)",
      background: "#25D366",
      padding: "12px",
      borderRadius: "50%",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      transition: "background 0.3s, transform 0.3s"
    }}>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "white", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <FaWhatsapp size={30} />
      </a>
    </div>
  );
};

export default WhatsappFloat;